// @flow
import { injectAsyncReducers, injectAsyncSagas, injectAsyncTrackers } from '~/core/state/store';
import { synchronousSagas } from '~/core/state/sagas-registration';

const seenNamedSagas = { ...synchronousSagas };

function setupBundle(bundle, store) {
    if (bundle.getReducers) {
        const newReducers = bundle.getReducers();
        injectAsyncReducers(store, newReducers);
    }

    if (bundle.getTrackers) {
        const newTrackers = bundle.getTrackers();
        injectAsyncTrackers(newTrackers);
    }

    if (bundle.getSagas) {
        let newSagas = bundle.getSagas();
        const isSagasArray = Array.isArray(newSagas);

        if (!isSagasArray) {
            newSagas = Object.keys(newSagas).reduce((agg, key) => {
                if (seenNamedSagas[key]) {
                    return agg;
                }

                seenNamedSagas[key] = true;
                return [...agg, ...newSagas[key]];
            }, []);
        }

        injectAsyncSagas(newSagas);
    }
}

export default function loadBundle(bundle: string, store: Object) {
    return import(`./${bundle}/entry`).then(loadedBundle => {
        setupBundle(loadedBundle, store);
        return loadedBundle.default;
    });
}



// WEBPACK FOOTER //
// ./src/routes/async-loader.js